<template>
  <div>

    <form class="evollu-form">
      <!-- Block Detail -->
      <div>
        <h5 class="text-evollu-gray-light is-bold mb-0 pl-3 py-3">
          {{ $t('iframe.blocks_builder.block_detail') }}
        </h5>
      </div>

      <div class="row col-12" style="margin-bottom: 0 !important;">
        <!-- input name -->
        <div class="col-6 col-md-6">
          <va-input
            id="name"
            v-model="value.name"
            :label="$t('iframe.blocks_builder.block_name')"
            :placeholder="$t('iframe.blocks_builder.block_name')"
            @input="formErrors.clear('name')"
          />

          <small v-show="formErrors.has('name')" class="help text-danger">
            {{ $t(formErrors.get('name')) }}
          </small>
        </div>
        <!-- --- --->

        <!-- input lang -->
        <div class="row col-md-6">
          <div class="col-12">
            <label class="form-label">{{ $t('iframe.table_headings.lang') }}</label>
            <multiselect
              :options="langOptions"
              id="lang"
              v-model="value.lang"
              :custom-label="opt => opt.language_key ? `${opt.emoji} ${$t(`language.${opt.language_key}`)}` : 'N/A'"
              track-by="lang"
              select-label=""
              selected-label=""
              deselect-label=""
              placeholder="---"
              open-direction="bottom"
              :allow-empty="false"
              :multiple="false"
              :searchable="true"
              @input="formErrors.clear('lang')"
            >
              <span slot="noResult">{{ $t('patients.noResults') }}</span>
            </multiselect>

            <small v-show="formErrors.has('lang')" class="help text-danger">
              {{ $t(formErrors.get('lang')) }}
            </small>
          </div>
        </div>
        <!-- --- --->
      </div>
      <!------------>

      <div class="row col-12">
        <div class="row col-md-6 ml-0">
          <div class="col-12 p-0">
            <label class="form-label">{{ $t('iframe.table_headings.client') }}</label>
            <multiselect
              :options="clientOptions"
              id="client"
              v-model="client"
              label="name"
              track-by="name"
              :disabled="clientOptions.length === 1"
              select-label=""
              selected-label=""
              deselect-label=""
              placeholder="---"
              open-direction="bottom"
              :allow-empty="false"
              :multiple="false"
              :searchable="true"
            >
              <span slot="noResult">{{ $t('patients.noResults') }}</span>
            </multiselect>
          </div>

        </div>
      </div>

      <!-- Titles Section -->
      <div>
        <h5 class="text-evollu-gray-light is-bold mb-0 pl-3 py-3">
          {{ $t('iframe.blocks_builder.title_section') }}
        </h5>
      </div>

      <div class="row col-12 mb-2">
        <!-- input title -->
        <div class="col-6 col-md-6 ">
          <va-input
            id="title"
            v-model="value.title"
            :label="$t('iframe.titles.title')"
            :placeholder="$t('iframe.titles.title')"
            @input="formErrors.clear('title')"
          />

          <small v-show="formErrors.has('title')" class="help text-danger">
            {{ $t(formErrors.get('title')) }}
          </small>
        </div>
        <!-- --- --->

        <!-- input subtitle -->
        <div class="col-6 col-md-6">
          <va-input
            id="message"
            type="textarea"
            :min-rows="2"
            v-model="value.subtitle"
            :label="$t('iframe.titles.subtitle')"
            :placeholder="$t('iframe.titles.subtitle')"
            @input="formErrors.clear('subtitle')"
          />

          <small v-show="formErrors.has('subtitle')" class="help text-danger">
            {{ $t(formErrors.get('subtitle')) }}
          </small>
        </div>
        <!-- --- --->
      </div>
      <!------------>

      <!-- Questionnaire Section -->
      <div>
        <h5 class="text-evollu-gray-light is-bold mb-0 pl-3 py-3">
          {{ $t('iframe.blocks_builder.questionnaire_block.questionnaire') }}
        </h5>

        <div class="row col-12">
          <div class="col-md-6">
            <label class="form-label">{{ $t('iframe.blocks_builder.questionnaire_block.select_questionnaire') }}</label>
            <multiselect
              :options="questionnairesOptions"
              id="lang"
              v-model="value.evohealth_anamnese_id"
              track-by="id"
              label="name"
              select-label=""
              selected-label=""
              deselect-label=""
              :placeholder="$t('iframe.blocks_builder.questionnaire_block.select_questionnaire')"
              open-direction="bottom"
              :allow-empty="false"
              :multiple="false"
              :searchable="true"
              @input="formErrors.clear('evohealth_anamnese_id')"
            >
              <span slot="noResult">{{ $t('patients.noResults') }}</span>
            </multiselect>

            <small v-show="formErrors.has('evohealth_anamnese_id')" class="help text-danger">
              {{ $t(formErrors.get('lead_questionnaire_id')) }}
            </small>
          </div>
        </div>
      </div>


    </form>
  </div>
</template>

<script>
import Errors from "@/utils/StandardErrors";
import Multiselect from 'vue-multiselect'
import {LeadsService} from "@/api/LeadsService";
import { EvohealthService } from '@/api/EvohealthService';

export default {
  components: {
    Multiselect,
  },
  props: {
    value: {
      type: Object,
      required: false
    },
    clientOptions: {
      type: Array,
      required: true,
    },
    formErrors: {
      type: Object,
      required: false,
      default: () => {
        return new Errors()
      }
    },
  },
  data() {
    return {
      langOptions: this.$store.state.languages,
      questionnairesOptions: [],
      client: {}
    }
  },
  mounted() {
    this.requestAnamneses()
    if(this.value && this.value.client_id) {
      this.value.client = this.clientOptions.find(elem => elem.id === parseInt(this.value.client_id))
      this.client = this.clientOptions.find(elem => elem.id === parseInt(this.value.client_id))
    }
  },
  methods: {
    requestAnamneses: function() {
      EvohealthService.getAnamneses()
      .then(res => {
        this.questionnairesOptions = res
        if(this.value.evohealth_anamnese_id) {
          this.value.evohealth_anamnese_id = this.questionnairesOptions.filter(opt => opt.id === parseInt(this.value.evohealth_anamnese_id))
        }
      }).catch(err => {
        console.log(err)
      })
    }
  },
  watch: {
    client: function (val) {
      if (val) {
        this.value.client = val
      }
    }
  }

}
</script>

<style scoped>

</style>
